(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-redirect"]) return;
  try {
    
const url = new URL(window.location.href);
url.searchParams.append('cart', '');
url.pathname = ''
document.querySelector('.redirect-url').href = url.toString()
window.location.replace(url.toString())

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-split"]) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  document.querySelector('header').classList.remove('spt-bg-white')
  document.querySelector('header').classList.add('spt-bg-cym-offwhite')
  document.querySelector('header').classList.add('md:spt-bg-white')
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {

  const fixSpr = async () => {
  if (document.querySelector('.spr-form form') === null) {
  throw 'Can\'t find shopify-product-reviews'
  }

  const addCancelButton = () => {
  const cancelButton = document.createElement('button')
  cancelButton.classList.add('spr-cancel-review')
  cancelButton.innerHTML = 'Nevermind'
  cancelButton.onclick = () => {
  document.querySelector('.spr-summary-actions-newreview').click()
  writeButton.classList.remove('spt-hidden')
  }

  const cancelButtonWrapper = document.createElement('div')
  cancelButtonWrapper.classList.add(
  'spt-flex', 'spt-w-full', 'spt-mr-2.5', 'md:spt-mt-3', 'xl:spt-mt-5'
  )
  cancelButtonWrapper.appendChild(cancelButton)

  const sprForm = document.querySelector('.spr-form form')
  sprForm.appendChild(cancelButtonWrapper)
  }

  const sprHeader = document.querySelector('.spr-header')
  const sprFormWrapper = document.querySelector('.spr-form')

  const writeButton = document.createElement('button')
  writeButton.classList.add('spr-write-review')
  writeButton.innerHTML = 'Write a review'
  writeButton.onclick = () => {
  document.querySelector('.spr-summary-actions-newreview').click()
  writeButton.classList.add('spt-hidden')
  addCancelButton()
  }

  sprHeader.insertBefore(writeButton, sprHeader.lastChild)
  }

  const removeRcWidget = () => {
  const cartForm = document.querySelector('form[action$="/cart/add"]')
  if (cartForm) {
  const rcWrapper = cartForm.querySelector('.rc-container-wrapper')
  if (rcWrapper === null) {
  throw 'Can\'t find recharge widget'
  }
  rcWrapper.remove()
  }
  }

  callRetry(fixSpr)
  callRetry(removeRcWidget)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product__option-picker"]) return;
  try {
    
  const optionSelects = [...document.querySelector('#product_option-picker').querySelectorAll('select')]
  const optionVariants = [...document.querySelector('#product_option-variants').querySelectorAll('option')];
  const setFromId = (variantId) => {
    const matchingOption = document.querySelector('#product_option-variants').querySelector(`option[value="${variantId}"]`)
    // from selectedOptions

    let option1 = matchingOption.dataset.option1;
    let option2 = matchingOption.dataset.option2;
    let option3 = matchingOption.dataset.option3;

    optionSelects.forEach((e, i) => {
      console.log(e, i)
      switch (i) {
        case 0:
          e.value = option1
          break;
        case 1:
          e.value = option2
          break;
        case 2:
          e.value = option3
          break;
      };
    })
  }
  const setFromOptions = () => {
    let option1 = '';
    let option2 = '';
    let option3 = '';

    const selectedOptions = [...document.querySelector('#product_option-picker').querySelectorAll('option:checked')];
    selectedOptions.forEach((e,i) => {
      switch (i) {
        case 0:
          option1 = e.value;
          break;
        case 1:
          option2 = e.value;
          break;
        case 2:
          option3 = e.value;
          break;
      };
    })

    const optionVariants = [...document.querySelector('#product_option-variants').querySelectorAll('option')];
    for (const [i, e] of optionVariants.entries()) {
      const optionsMatched = e.dataset.option1 === option1 && e.dataset.option2 === option2 && e.dataset.option3 === option3
      if (optionsMatched) {
        document.querySelector('#product_option-variants').value = e.value
        break
      }
    }
  }

  const queryVariantId = (new URLSearchParams(window.location.search)).get("variant")
  if (queryVariantId) {
    setFromId(Number(queryVariantId))
  }
  optionSelects.forEach((e) => {
    e.oninput = setFromOptions
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-home-shop-by-goal"]) return;
  try {
    
  const swiper = new Swiper(".shop-by-goal-swiper", {
    loop: true,
    slidesPerView: 3,
    slidesPerGroup: 3,
    breakpoints: {
      480: {
        slidesPerView: 5
      },
      768: {
        slidesPerView: 7
      },
      960: {
        slidesPerView: 7
      },
      1280: {
        slidesPerView: 9,
        allowTouchMove: false
      },
      1512: {
        slidesPerView: 9,
        allowTouchMove: false
      }
    }
  })

  // ga
  const benefits = document.querySelectorAll('.shop-by-goal-swiper a')
  for (const benefit of benefits) {
    benefit.addEventListener('click', () => {
      window.cym.event( 'Home', 'HowCanWeHelp', benefit.innerText)
    })
  }

  document.querySelector('#home-shop-by-goal button.left')
    .addEventListener('click', () => {
      swiper.slidePrev()
    })

  document.querySelector('#home-shop-by-goal button.right')
    .addEventListener('click', () => {
      swiper.slideNext()
    })

  } catch(e) { console.error(e); }
})();
})();
